import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { ItemFormContainer } from './styles';

import InputGroup from '../../styled/InputGroup';
import Input from '../../styled/Input';
import Button from '../../styled/Button';
import AddButton from '../../styled/AddButton';

import UnitForm from '../../UnitForm';

class ExpenseForm extends Component {
    handleSuggestionSelect = (e, { suggestion }) => {
        const { sales } = this.props.store;
        sales.expenseForm.setValues(suggestion);
    };

    render() {
        const { store } = this.props;

        const { expenseForm } = store.sales;

        const unitOptions = Object.assign([], store.common.units);

        const AddUnitButton = (
            <AddButton
                tooltip="Lisa uus ühik"
                type="button"
                value="+"
                size="2rem"
                onClick={() => store.ui.showModal(<UnitForm />)}
            />
        );

        return (
            <ItemFormContainer onSubmit={expenseForm.submit}>
                <Input
                    required
                    type="autosuggest"
                    getSuggestionValue={item => item.name}
                    fetchSuggestions={value =>
                        store.app.api.items.search({
                            name: value,
                            itemType: { id: 2 }
                        })
                    }
                    onSuggestionSelected={this.handleSuggestionSelect}
                    value={expenseForm.values.name}
                    errors={expenseForm.errors.name}
                    name="name"
                    onChange={expenseForm.handleChange}
                    label="Nimetus"
                />
                <InputGroup flex={[2, 1]} actionComponent={AddUnitButton}>
                    <Input
                        required
                        value={expenseForm.values.quantity}
                        errors={expenseForm.errors.quantity}
                        type="number"
                        name="quantity"
                        onChange={expenseForm.handleChange}
                        label="Kogus"
                    />
                    <Input
                        options={unitOptions}
                        value={expenseForm.values.unit}
                        parseValue={value => ({ label: value.abbr, value })}
                        errors={expenseForm.errors.unit}
                        type="select"
                        name="unit"
                        onChange={expenseForm.handleChange}
                        label="Ühik"
                    />
                </InputGroup>
                <Input
                    required
                    value={expenseForm.values.retailPrice}
                    errors={expenseForm.errors.retailPrice}
                    type="number"
                    step="0.01"
                    name="retailPrice"
                    onChange={expenseForm.handleChange}
                    label="Müügihind"
                />
                <Button value="Lisa kuluartikkel" />
            </ItemFormContainer>
        );
    }
}

export default inject('store')(observer(ExpenseForm));
